import React from 'react'

const InputWithIcon = function (props) {
  const {
    children,
    containerClass,
    disabled,
    fieldName,
    iConColor,
    rightIconColor,
    iconName,
    rightIconName,
    iconSize,
    id,
    inputClass,
    leftIcon,
    rightIcon,
    onChangeHandler,
    onKeyUpHandler,
    onKeyDownHandler,
    onKeyPressHandler,
    placeholder,
    value
  } = props

  return (
    <div className={`relative ${containerClass || 'flex items-center w-full flex-grow'}`}>
      {
        leftIcon &&
        <span className='absolute left-0 pl-2 inset-y-0 flex items-center'>
          {
            iconName === null ?
            <div className='contents'>{children}</div>
            :
            <hero-icon-outline name={iconName} class={`${iconSize || 'w-4 h-4'} ${iConColor || 'text-base-gray-text-secondary'}`}></hero-icon-outline>
          }
        </span>
      }
      <input
        type='text'
        id={id}
        name={fieldName}
        className={`block input-text-base ${inputClass} ${leftIcon ? 'pl-8' : ''} ${rightIcon ? 'pr-8' : ''}`}
        placeholder={placeholder}
        onChange={onChangeHandler}
        onKeyUp={(e) => { onKeyUpHandler && onKeyUpHandler(e); }}
        onKeyDown={(e) => { onKeyDownHandler && onKeyDownHandler(e); }}
        onKeyPress={(e) => { onKeyPressHandler && onKeyPressHandler(e); }}
        value={value}
        disabled={disabled}
      />
      {
        rightIcon &&
        <span className='absolute right-0 pr-2 inset-y-0 flex items-center'>
          {
            rightIconName === null ?
            <div className='contents'>{children}</div>
            :
            <hero-icon-solid name={rightIconName} class={`${iconSize || 'w-4 h-4'} ${rightIconColor || 'text-base-gray-text-secondary'}`}></hero-icon-solid>
          }
        </span>
      }
    </div>
  )
}

export default InputWithIcon
